import React, { useState } from 'react';
import { t } from '../../../locales/translate';
import { Card } from '../../../components/Card/Card';
import { KeyValueTable } from '../../../components/KeyValueTable/KeyValueTable';
import { ShowVenueLayoutQuery } from '../../../generated/graphql';
import { PermissionButton } from '../../../components/Button/PermissionButton';
import { Modal } from '../../../components/Modal/Modal';
import { VenueLayoutForm } from './VenueLayoutForm';

interface Props {
  venueLayout: ShowVenueLayoutQuery['venueLayout'];
  onChange: () => void;
}

export function DetailsCard({ venueLayout, onChange }: Props): JSX.Element {
  const [showEditModal, setShowEditModal] = useState(false);

  return (
    <Card
      title={t.general.details}
      actions={
        <PermissionButton
          name="edit"
          model={venueLayout}
          permission="update"
          onClick={() => setShowEditModal(true)}
          tooltip={t.actions.edit(t.model.venueLayout._name)}
        />
      }
    >
      <KeyValueTable
        items={[
          {
            key: t.model.venueLayout.name,
            value: venueLayout.name,
          },
          {
            key: t.model.venueLayout.capacity,
            value: venueLayout.capacity,
          },
        ]}
      />
      <Modal open={showEditModal} title={t.actions.edit(t.model.venueLayout._name)} size="xs">
        <VenueLayoutForm venueLayout={venueLayout} onClose={() => setShowEditModal(false)} onSaved={onChange} />
      </Modal>
    </Card>
  );
}
